import cn from 'classnames';
import React, { forwardRef } from 'react';
import styles from './Text.module.css';

export type TextVariant = 'default' | 'title' | 'heading' | 'subheading' | 'body' | 'helper';

export interface TextProps {
  variant: TextVariant;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const Text = forwardRef<HTMLDivElement, TextProps>(function TextForwardRefWrapper(
  { children, variant, ...props },
  ref,
) {
  const className = cn(props.className, styles[variant]);

  return (
    <div ref={ref} {...props} className={className}>
      {children}
    </div>
  );
});

export default Text;
